import {ComponentPropertiesPane} from '../components/NodePropertiesPane.jsx'
import {useProperties} from '../../SidePanel/RightPanel/Properties.mjs'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Select from '../../SidePanel/RightPanel/PropertiesControllerSelect.jsx'
import TagSelect from '../../SidePanel/RightPanel/PropertiesControllerTagSelect.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import Model from './ModelBdrule.mjs'
import RuleType from './RuleType.jsx'

const _Analyse = props => {
    const [{ruleType}] = useProperties()

    const modes = 'IS' === ruleType ?
        [
            'ApiEffect',
            'ChgReferenceSingle',
            'Effect',
            'Reference',
            'ReferenceCall',
            'IsrfReference',
        ]
        :
        [
            'ChgReferenceSingle',
            'Effect',
            'Reference',
            'ReferenceCall',
            'IsrfReference',
        ]

    return (
        <Analyse
            modes={modes}
            {...props}
        />
    )
}

const PropertiesPaneBdrule = (props) => (
    <ComponentPropertiesPane
        controllers={
            <>
                <Text prop="ruleTitle" />
                <Text prop="ruleUserCode" />

                <Select
                    options={RuleType}
                    prop="ruleType"
                />

                <TagSelect prop="ruleKey" />
                <LongText prop="resume" />
            </>
        }

        Model={Model}
        snSuffix={<_Analyse />}
        {...props}
    />
)

export default PropertiesPaneBdrule
